import React from 'react';
import styles from './ImageContent.module.scss';

const ImageContent = ({ data }) => (
  <div
    className={styles.imageContent}
    style={{ backgroundImage: `url(${data.imageUrl})` }}
  />
);

export default ImageContent;
